import loadable from '@loadable/component';

export const OrgDashboardGradFairHomeContainerLoadable = loadable(
  () => import('./OrgDashboardGradFairHomeContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardGradFairHomeContainer,
  },
);
